// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6a794425","147":"3c86abb4"}[chunkId] + ".chunk.js";
};